import React from 'react';
import { CheckIcon } from 'lucide-react';
import { coreModules } from '../data/modules';
import { ModuleCard } from './ModuleCard';
const INCLUSIONS = ['Letra grande', 'Ilustraciones claras', 'Instrucciones simples', 'Material imprimible'];
export const ModulesSection = () => {
  return <section id="modulos" className="bg-familia-light border-t border-familia-lightBorder py-12 md:py-16 px-4 md:px-6" data-id="element-151" data-mp="1dwqjx1gd1i6i">
      <div className="max-w-7xl mx-auto w-full" data-id="element-152" data-mp="2bkiinzv2grg7">
        <div className="text-center mb-8 md:mb-14" data-id="element-153" data-mp="2bi5z5i9nu911">
          <h2 className="text-[26px] sm:text-3xl md:text-5xl font-display font-bold text-familia-ink mb-4 md:mb-6 leading-tight" data-id="element-154" data-mp="26m76vjl7o6vc">
            Los 5 módulos centrales
          </h2>
          <p className="text-body text-familia-inkMuted max-w-3xl mx-auto" data-id="element-155" data-mp="1wnhpdrx88ofm">
            Cada módulo combina actividades para tu familiar, guía para vos o el
            cuidador, registros de salud e instrucciones claras en cada página.
          </p>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-3 md:gap-6 mb-10 md:mb-16" data-id="element-156" data-mp="l9xbry0n5gmh">
          {coreModules.map(m => <ModuleCard key={m.num} module={m} data-id="element-157" data-mp="1nu1u0wkwm3qe" />)}
        </div>
        <div className="bg-familia-lightCard border-2 border-familia-lightBorder border-dashed p-6 md:p-10 rounded-3xl max-w-4xl mx-auto" data-id="element-158" data-mp="1ntjzc4dw3xkl">
          <h3 className="text-xl md:text-2xl font-display font-bold text-familia-ink mb-6 text-center" data-id="element-159" data-mp="1dvmezrz5ikx9">
            Cada módulo incluye:
          </h3>
          <ul className="grid grid-cols-1 sm:grid-cols-2 gap-x-10 gap-y-3" data-id="element-160" data-mp="103fxo2k9i7w8">
            {INCLUSIONS.map(item => <li key={item} className="flex items-center gap-3" data-id="element-161" data-mp="14wsc5jv88yb9">
                <CheckIcon className="w-5 h-5 text-familia-check shrink-0" strokeWidth={3} aria-hidden="true" data-id="element-162" data-mp="q7mei0c1fg5h" />
                <span className="text-body font-medium text-familia-ink" data-id="element-163" data-mp="v6ft5w329d78">
                  {item}
                </span>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
};